package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class SkillResourceQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    skill_id: String,
    step_id: String?,
    origin: String,
    format: String,
    title: String,
    url: String?,
    body: String?,
    order_index: Long,
    index_status: String?,
    index_error: String?,
    indexed_at: Long?,
    refresh_error: String?,
    push_error: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_101_417_820, arrayOf("skill_resource"), driver, "SkillResource.sq",
      "selectAll",
      "SELECT skill_resource.id, skill_resource.skill_id, skill_resource.step_id, skill_resource.origin, skill_resource.format, skill_resource.title, skill_resource.url, skill_resource.body, skill_resource.order_index, skill_resource.index_status, skill_resource.index_error, skill_resource.indexed_at, skill_resource.refresh_error, skill_resource.push_error, skill_resource.created_at, skill_resource.updated_at, skill_resource.is_deleted, skill_resource.deleted_at, skill_resource.synced_at FROM skill_resource WHERE is_deleted = 0 ORDER BY skill_id, order_index, created_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17),
      cursor.getLong(18)
    )
  }

  public fun selectAll(): Query<Skill_resource> = selectAll { id, skill_id, step_id, origin, format,
      title, url, body, order_index, index_status, index_error, indexed_at, refresh_error,
      push_error, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Skill_resource(
      id,
      skill_id,
      step_id,
      origin,
      format,
      title,
      url,
      body,
      order_index,
      index_status,
      index_error,
      indexed_at,
      refresh_error,
      push_error,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectBySkill(skill_id: String, mapper: (
    id: String,
    skill_id: String,
    step_id: String?,
    origin: String,
    format: String,
    title: String,
    url: String?,
    body: String?,
    order_index: Long,
    index_status: String?,
    index_error: String?,
    indexed_at: Long?,
    refresh_error: String?,
    push_error: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectBySkillQuery(skill_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17),
      cursor.getLong(18)
    )
  }

  public fun selectBySkill(skill_id: String): Query<Skill_resource> = selectBySkill(skill_id) { id,
      skill_id_, step_id, origin, format, title, url, body, order_index, index_status, index_error,
      indexed_at, refresh_error, push_error, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Skill_resource(
      id,
      skill_id_,
      step_id,
      origin,
      format,
      title,
      url,
      body,
      order_index,
      index_status,
      index_error,
      indexed_at,
      refresh_error,
      push_error,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectTrashBySkill(
    skill_id: String,
    deleted_at: Long?,
    mapper: (
      id: String,
      skill_id: String,
      step_id: String?,
      origin: String,
      format: String,
      title: String,
      url: String?,
      body: String?,
      order_index: Long,
      index_status: String?,
      index_error: String?,
      indexed_at: Long?,
      refresh_error: String?,
      push_error: String?,
      created_at: Long,
      updated_at: Long,
      is_deleted: Long,
      deleted_at: Long?,
      synced_at: Long?,
    ) -> T,
  ): Query<T> = SelectTrashBySkillQuery(skill_id, deleted_at) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17),
      cursor.getLong(18)
    )
  }

  public fun selectTrashBySkill(skill_id: String, deleted_at: Long?): Query<Skill_resource> =
      selectTrashBySkill(skill_id, deleted_at) { id, skill_id_, step_id, origin, format, title, url,
      body, order_index, index_status, index_error, indexed_at, refresh_error, push_error,
      created_at, updated_at, is_deleted, deleted_at_, synced_at ->
    Skill_resource(
      id,
      skill_id_,
      step_id,
      origin,
      format,
      title,
      url,
      body,
      order_index,
      index_status,
      index_error,
      indexed_at,
      refresh_error,
      push_error,
      created_at,
      updated_at,
      is_deleted,
      deleted_at_,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    skill_id: String,
    step_id: String?,
    origin: String,
    format: String,
    title: String,
    url: String?,
    body: String?,
    order_index: Long,
    index_status: String?,
    index_error: String?,
    indexed_at: Long?,
    refresh_error: String?,
    push_error: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17),
      cursor.getLong(18)
    )
  }

  public fun selectById(id: String): Query<Skill_resource> = selectById(id) { id_, skill_id,
      step_id, origin, format, title, url, body, order_index, index_status, index_error, indexed_at,
      refresh_error, push_error, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Skill_resource(
      id_,
      skill_id,
      step_id,
      origin,
      format,
      title,
      url,
      body,
      order_index,
      index_status,
      index_error,
      indexed_at,
      refresh_error,
      push_error,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun countLive(skill_id: String): Query<Long> = CountLiveQuery(skill_id) { cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> selectLinks(skill_id: String, mapper: (id: String, url: String?) -> T):
      Query<T> = SelectLinksQuery(skill_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)
    )
  }

  public fun selectLinks(skill_id: String): Query<SelectLinks> = selectLinks(skill_id) { id, url ->
    SelectLinks(
      id,
      url
    )
  }

  public fun maxOrder(skill_id: String): Query<Long> = MaxOrderQuery(skill_id) { cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    skill_id: String,
    step_id: String?,
    origin: String,
    format: String,
    title: String,
    url: String?,
    body: String?,
    order_index: Long,
    index_status: String?,
    index_error: String?,
    indexed_at: Long?,
    refresh_error: String?,
    push_error: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_897_879_531, arrayOf("skill_resource"), driver, "SkillResource.sq",
      "selectDirty",
      "SELECT skill_resource.id, skill_resource.skill_id, skill_resource.step_id, skill_resource.origin, skill_resource.format, skill_resource.title, skill_resource.url, skill_resource.body, skill_resource.order_index, skill_resource.index_status, skill_resource.index_error, skill_resource.indexed_at, skill_resource.refresh_error, skill_resource.push_error, skill_resource.created_at, skill_resource.updated_at, skill_resource.is_deleted, skill_resource.deleted_at, skill_resource.synced_at FROM skill_resource WHERE (synced_at IS NULL OR synced_at < updated_at) AND push_error IS NULL") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17),
      cursor.getLong(18)
    )
  }

  public fun selectDirty(): Query<Skill_resource> = selectDirty { id, skill_id, step_id, origin,
      format, title, url, body, order_index, index_status, index_error, indexed_at, refresh_error,
      push_error, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Skill_resource(
      id,
      skill_id,
      step_id,
      origin,
      format,
      title,
      url,
      body,
      order_index,
      index_status,
      index_error,
      indexed_at,
      refresh_error,
      push_error,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    skill_id: String,
    step_id: String?,
    origin: String,
    format: String,
    title: String,
    url: String?,
    body: String?,
    order_index: Long,
    index_status: String?,
    index_error: String?,
    indexed_at: Long?,
    refresh_error: String?,
    push_error: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17),
      cursor.getLong(18)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Skill_resource> = selectByIdAnyState(id) { id_,
      skill_id, step_id, origin, format, title, url, body, order_index, index_status, index_error,
      indexed_at, refresh_error, push_error, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Skill_resource(
      id_,
      skill_id,
      step_id,
      origin,
      format,
      title,
      url,
      body,
      order_index,
      index_status,
      index_error,
      indexed_at,
      refresh_error,
      push_error,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    skill_id: String,
    step_id: String?,
    origin: String,
    format: String,
    title: String,
    url: String?,
    body: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(985_409_402, """
        |INSERT INTO skill_resource(id, skill_id, step_id, origin, format, title, url, body, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 11) {
          bindString(0, id)
          bindString(1, skill_id)
          bindString(2, step_id)
          bindString(3, origin)
          bindString(4, format)
          bindString(5, title)
          bindString(6, url)
          bindString(7, body)
          bindLong(8, order_index)
          bindLong(9, created_at)
          bindLong(10, updated_at)
        }
    notifyQueries(985_409_402) { emit ->
      emit("skill_resource")
    }
  }

  public fun rename(
    title: String,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_234_607_103,
        """UPDATE skill_resource SET title = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, title)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_234_607_103) { emit ->
      emit("skill_resource")
    }
  }

  public fun updateText(
    title: String,
    body: String?,
    format: String,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_576_370_647,
        """UPDATE skill_resource SET title = ?, body = ?, format = ?, updated_at = ? WHERE id = ?""",
        5) {
          bindString(0, title)
          bindString(1, body)
          bindString(2, format)
          bindLong(3, updated_at)
          bindString(4, id)
        }
    notifyQueries(1_576_370_647) { emit ->
      emit("skill_resource")
    }
  }

  public fun setOrder(
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_350_401_907,
        """UPDATE skill_resource SET order_index = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, order_index)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_350_401_907) { emit ->
      emit("skill_resource")
    }
  }

  public fun updateFromRemote(
    skill_id: String,
    step_id: String?,
    origin: String,
    format: String,
    title: String,
    url: String?,
    body: String?,
    order_index: Long,
    index_status: String?,
    index_error: String?,
    indexed_at: Long?,
    refresh_error: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_734_060_474, """
        |UPDATE skill_resource
        |SET skill_id = ?, step_id = ?, origin = ?, format = ?, title = ?, url = ?, body = ?, order_index = ?,
        |    index_status = ?, index_error = ?, indexed_at = ?, refresh_error = ?, push_error = NULL, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 14) {
          bindString(0, skill_id)
          bindString(1, step_id)
          bindString(2, origin)
          bindString(3, format)
          bindString(4, title)
          bindString(5, url)
          bindString(6, body)
          bindLong(7, order_index)
          bindString(8, index_status)
          bindString(9, index_error)
          bindLong(10, indexed_at)
          bindString(11, refresh_error)
          bindLong(12, updated_at)
          bindString(13, id)
        }
    notifyQueries(1_734_060_474) { emit ->
      emit("skill_resource")
    }
  }

  public fun insertFromRemote(
    id: String,
    skill_id: String,
    step_id: String?,
    origin: String,
    format: String,
    title: String,
    url: String?,
    body: String?,
    order_index: Long,
    index_status: String?,
    index_error: String?,
    indexed_at: Long?,
    refresh_error: String?,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-1_059_289_174, """
        |INSERT INTO skill_resource(id, skill_id, step_id, origin, format, title, url, body, order_index,
        |    index_status, index_error, indexed_at, refresh_error, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 15) {
          bindString(0, id)
          bindString(1, skill_id)
          bindString(2, step_id)
          bindString(3, origin)
          bindString(4, format)
          bindString(5, title)
          bindString(6, url)
          bindString(7, body)
          bindLong(8, order_index)
          bindString(9, index_status)
          bindString(10, index_error)
          bindLong(11, indexed_at)
          bindString(12, refresh_error)
          bindLong(13, created_at)
          bindLong(14, updated_at)
        }
    notifyQueries(-1_059_289_174) { emit ->
      emit("skill_resource")
    }
  }

  public fun markRefused(push_error: String?, id: String) {
    driver.execute(-1_908_256_990,
        """UPDATE skill_resource SET push_error = ?, synced_at = updated_at WHERE id = ?""", 2) {
          bindString(0, push_error)
          bindString(1, id)
        }
    notifyQueries(-1_908_256_990) { emit ->
      emit("skill_resource")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_276_721_846,
        """UPDATE skill_resource SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_276_721_846) { emit ->
      emit("skill_resource")
    }
  }

  public fun restoreFromTrash(updated_at: Long, id: String) {
    driver.execute(650_943_041,
        """UPDATE skill_resource SET is_deleted = 0, push_error = NULL, updated_at = ? WHERE id = ? AND is_deleted = 1""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(650_943_041) { emit ->
      emit("skill_resource")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-376_699_411,
        """UPDATE skill_resource SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-376_699_411) { emit ->
      emit("skill_resource")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-1_815_351_832, """
        |UPDATE skill_resource
        |SET synced_at = ?,
        |    deleted_at = CASE WHEN is_deleted = 0 THEN NULL ELSE deleted_at END
        |WHERE id = ? AND updated_at <= ?
        """.trimMargin(), 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-1_815_351_832) { emit ->
      emit("skill_resource")
    }
  }

  private inner class SelectBySkillQuery<out T : Any>(
    public val skill_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("skill_resource", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("skill_resource", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(153_021_373,
        """SELECT skill_resource.id, skill_resource.skill_id, skill_resource.step_id, skill_resource.origin, skill_resource.format, skill_resource.title, skill_resource.url, skill_resource.body, skill_resource.order_index, skill_resource.index_status, skill_resource.index_error, skill_resource.indexed_at, skill_resource.refresh_error, skill_resource.push_error, skill_resource.created_at, skill_resource.updated_at, skill_resource.is_deleted, skill_resource.deleted_at, skill_resource.synced_at FROM skill_resource WHERE skill_id = ? AND is_deleted = 0 ORDER BY order_index, created_at""",
        mapper, 1) {
      bindString(0, skill_id)
    }

    override fun toString(): String = "SkillResource.sq:selectBySkill"
  }

  private inner class SelectTrashBySkillQuery<out T : Any>(
    public val skill_id: String,
    public val deleted_at: Long?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("skill_resource", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("skill_resource", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_162_855_361,
        """SELECT skill_resource.id, skill_resource.skill_id, skill_resource.step_id, skill_resource.origin, skill_resource.format, skill_resource.title, skill_resource.url, skill_resource.body, skill_resource.order_index, skill_resource.index_status, skill_resource.index_error, skill_resource.indexed_at, skill_resource.refresh_error, skill_resource.push_error, skill_resource.created_at, skill_resource.updated_at, skill_resource.is_deleted, skill_resource.deleted_at, skill_resource.synced_at FROM skill_resource WHERE skill_id = ? AND is_deleted = 1 AND deleted_at >= ? ORDER BY deleted_at DESC""",
        mapper, 2) {
      bindString(0, skill_id)
      bindLong(1, deleted_at)
    }

    override fun toString(): String = "SkillResource.sq:selectTrashBySkill"
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("skill_resource", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("skill_resource", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(215_827_247,
        """SELECT skill_resource.id, skill_resource.skill_id, skill_resource.step_id, skill_resource.origin, skill_resource.format, skill_resource.title, skill_resource.url, skill_resource.body, skill_resource.order_index, skill_resource.index_status, skill_resource.index_error, skill_resource.indexed_at, skill_resource.refresh_error, skill_resource.push_error, skill_resource.created_at, skill_resource.updated_at, skill_resource.is_deleted, skill_resource.deleted_at, skill_resource.synced_at FROM skill_resource WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "SkillResource.sq:selectById"
  }

  private inner class CountLiveQuery<out T : Any>(
    public val skill_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("skill_resource", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("skill_resource", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_966_091_834,
        """SELECT count(*) FROM skill_resource WHERE skill_id = ? AND is_deleted = 0 AND push_error IS NULL""",
        mapper, 1) {
      bindString(0, skill_id)
    }

    override fun toString(): String = "SkillResource.sq:countLive"
  }

  private inner class SelectLinksQuery<out T : Any>(
    public val skill_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("skill_resource", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("skill_resource", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_890_495_492,
        """SELECT id, url FROM skill_resource WHERE skill_id = ? AND is_deleted = 0 AND origin = 'link' AND push_error IS NULL""",
        mapper, 1) {
      bindString(0, skill_id)
    }

    override fun toString(): String = "SkillResource.sq:selectLinks"
  }

  private inner class MaxOrderQuery<out T : Any>(
    public val skill_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("skill_resource", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("skill_resource", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_937_107_147,
        """SELECT coalesce(max(order_index), 0) FROM skill_resource WHERE skill_id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, skill_id)
    }

    override fun toString(): String = "SkillResource.sq:maxOrder"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("skill_resource", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("skill_resource", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-271_141_292,
        """SELECT skill_resource.id, skill_resource.skill_id, skill_resource.step_id, skill_resource.origin, skill_resource.format, skill_resource.title, skill_resource.url, skill_resource.body, skill_resource.order_index, skill_resource.index_status, skill_resource.index_error, skill_resource.indexed_at, skill_resource.refresh_error, skill_resource.push_error, skill_resource.created_at, skill_resource.updated_at, skill_resource.is_deleted, skill_resource.deleted_at, skill_resource.synced_at FROM skill_resource WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "SkillResource.sq:selectByIdAnyState"
  }
}
